var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldDirectLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.552 13.542c-.48-.97-.48-2.1 0-3.07l1.74-3.48c1.49-2.99-1.72-6.13-4.67-4.57l-1.54.82c-.21.11-.38.29-.48.51l-5.7 12.64c-.23.52-.02 1.13.48 1.39l7.24 3.81c2.95 1.56 6.16-1.59 4.67-4.57l-1.74-3.48zM11.42 7.32c.42-.93-.58-1.87-1.48-1.39L4.17 8.96c-2.45 1.29-2.45 4.79 0 6.08l2.04 1.07c.55.29 1.22.06 1.48-.51l3.73-8.28z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldDirectLeft);
export default __webpack_public_path__ + "static/media/vuesax-bold-direct-left.74a6f69e16faa33f7f0c9f40d012050c.svg";
export { ForwardRef as ReactComponent };